import SimpleHeader from './simple-header';
import SimpleSignIn from './simple-sign-in';
import SimpleUserProfile from './simple-user-profile';
import { ArrowSmRightIcon } from '@heroicons/react/solid';

export function Code({ signIn, userProfile }: any) {
  return (
    <section className="mt-28" id="simple">
      <SimpleHeader />
      <div className="">
        <SimpleSignIn imagePosition="right" signIn={signIn} />
        <SimpleUserProfile imagePosition="right" userProfile={userProfile} />
        <div className="max-w-md mx-auto mt-5 sm:flex sm:justify-center md:mt-8">
          <div className="mx-8 rounded-md">
            <a
              href="/docs/component-reference/overview"
              target="_blank"
              className="flex items-center justify-center w-full px-8 py-3 text-base font-medium text-white border border-transparent rounded-md bg-clerk-blue hover:bg-blue-700 md:py-4 md:text-lg md:px-10 btn"
              rel="noopener"
            >
              See all components
              <ArrowSmRightIcon className="w-6 h-6 ml-1 -mr-1.5" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
